module.exports = __webpack_public_path__ + "img/tab-12.927ba0d1.png";